<template>
    <modal-pro></modal-pro>
    <section class="products-grid">
        <router-link :to="{name : 'PS'}" class="product-card card-ps">
            <div class="card-overlay"></div>
            <span class="card-label"><span class="colored">Steri</span>Spine<sup>TM</sup> <span class="colored">PS</span></span>
            <h2 class="card-title" v-html="$t('products.psTitle')"></h2>
        </router-link>
        <router-link :to="{name : 'VA'}" class="product-card card-va">
            <div class="card-overlay"></div>
            <span class="card-label"><span class="colored">Steri</span>Spine<sup>TM</sup> <span class="colored">VA</span></span>
            <h2 class="card-title" v-html="$t('products.vaTitle')"></h2>
        </router-link>
        <router-link :to="{name : 'LC'}" class="product-card card-lc">
            <div class="card-overlay"></div>
            <span class="card-label"><span class="colored">Steri</span>Spine<sup>TM</sup> <span class="colored">CC</span>/<span class="colored">LC</span></span>
            <h2 class="card-title" v-html="$t('products.lcccTitle')"></h2>
        </router-link>
    </section>
</template>

<script>
import ModalPro from "./../components/ModalPro.vue";

export default {
  name: "Products",
  components : { ModalPro }
}
</script>

<style scoped lang="scss">

.products-grid {
  display: flex;
  width: 100%;
  padding-top: 80px;
  min-height: calc(100vh - 80px);
}

.product-card {
  position: relative;
  flex: 1;
  min-height: 640px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow: hidden;
}

.card-ps {
  background-image: url("./../assets/products/FP.png");
}

.card-va {
  background-image: url("./../assets/products/FSV.png");
}

.card-lc {
  background-image: url("./../assets/products/FI.png");
}

.card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.15);
  transition: 0.5s;
}

.product-card:hover .card-overlay {
  background: rgba(0, 0, 0, 0.45);
}

.card-label {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  z-index: 1;
  text-align: center;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 15px;
  font-weight: 500;
}

.card-label sup {
  font-size: 9px;
}

.card-title {
  position: relative;
  z-index: 1;
  color: #fff;
  font-weight: 300;
  font-size: 42px;
  line-height: 1.3em;
  text-align: center;
  padding: 0 30px;
  margin: 0;
}

@media screen and (max-width:900px) {
  .products-grid {
    flex-direction: column;
    padding-top: 60px;
    min-height: auto;
  }

  .product-card {
    min-height: 320px;
  }

  .card-title {
    font-size: 30px;
  }
}
</style>
